/**
 * Analytics event name constants
 */
const ANALYTICS_EVENT_NAMES = {
  AI_GEN_SCREEN_ACTION: 'ai_gen_screen_action',
  AI_GEN_ITEM_LOAD: 'ai_gen_item_load',
  OBJECT_APPLY: 'object_apply',
  OBJECT_EXPORT: 'object_export',
  PHOTO_EDITOR_OPEN: 'photo_editor_open',
  CONTENT_TRY: 'content_try',
} as const;

export default ANALYTICS_EVENT_NAMES;
